module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_core-js@2.5.7@core-js/library/modules/_add-to-unscopables.js
// module id = 443
// module chunks = 0